// extracted by mini-css-extract-plugin
var _1 = "IdwellToIdwellSubMenuCompanyList-moduleIdwellToIdwellSubMenuCompanyList__cOL4P";
export { _1 as "IdwellToIdwellSubMenuCompanyList" }
